<!--教师年龄-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -30px;"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "teaStationEchart",
    props: {
        id:{
            type: String,
            default:"tea_station_echart"
        },
        count1:{
            type: Number,
            default: 0
        },
        count2:{
            type: Number,
            default: 0
        },
        count3:{
            type: Number,
            default: 0
        },
        count4:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    show:false,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: true,
                    bottom:-5,
                    textStyle: {
                        color: '#101010',
                    },
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            lineHeight:30,
                            fontSize: 20,
                            fontWeight: 'bold'
                        },
                    },
                ],
                series: [
                    {
                        name: '岗位分布：',
                        type: 'pie',
                        radius: '60%',
                        color: [
                            '#91cc75',
                            '#fac858',
                            '#ee6666',
                            '#3ba272',
                            '#fc8452',
                            '#9a60b4',
                            '#ea7ccc',
                        ],
                        label: {
                            show: false,
                            position: 'right'
                        },

                        labelLine: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.count1,'name':"教学教研"});
            list.push({'value':this.count2,'name':"行政管理"});
            list.push({'value':this.count3,'name':"后勤服务"});
            list.push({'value':this.count4,'name':"专项支持"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    width: 100%;
    height: calc(50vh - 120px);
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 120px);
    }
}
</style>